import { combineReducers } from 'redux';

import choices from './worksheetChoicesReducer';
import feedback from './worksheetFeedbackReducer';

const worksheetReducer = combineReducers({
  choices,
  feedback,
});

export default worksheetReducer;
